export default [
  {
    "Title": "The Legend of Brewers Cave",
    "Featuring": "Utahna Jessop",
    "Image": "",
    "Description": "Exploring the many tales and the ongoing saga of Brewers Cave",
    "Location": "Provo City Library",
    "Date": "Jan 23, 2025",
    "Time": "6:00 PM",
    "Cost": "Free",
    "Link": "https://filmdaily.co/wp-content/uploads/2020/05/dog-videos-lede-1300x868.jpg"
  },
  // {
  //   "Title": "The Importance of Dr Pepper in Life",
  //   "Featuring": "Taylor Dearden",
  //   // "Image": "https://lh3.googleusercontent.com/pw/ACtC-3dplFFXtb3pn28092aDRGOkCgzZickQK9oNuj7SuedAIATw64iHF6SaW2C64uItxlS9z561NT6VEhfgYHER2R9nvQrGAmHNob0eGSiFUPKPb7Qv-Pu4gR1K5ibvH7I4JvT8XTVmDSOkODCQeexILu9-IQ=s800-no?authuser=0",
  //   "Description": "Taylor has drank more than 22,000 cans of Dr Pepper in his lifetime.",
  //   "Location": "Snow College Library",
  //   "Date": "Feb 22, 2026",
  //   "Time": "5:00 PM",
  //   "Cost": "$10",
  //   "Link": "https://filmdaily.co/wp-content/uploads/2020/05/dog-videos-lede-1300x868.jpg"
  // }
 ]